import { DefaultPlayHost } from '@/integration/default-host-system';
import { HostSystem } from '@/generated/play-api';

export const MaxClassicHost = new DefaultPlayHost(HostSystem.CLASSIC, {
    name: 'Max Classic',
    initialize() {
        return {};
    },
});
